// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
}


/* src/components/Preview/PreviewRoot.css */
.prevWrap{
  width: 400px;
  min-width: 400px;
}
.preview-container {
  display: flex;
  flex-direction: column;
  height: 95%;
  border: 1px solid #e1e4e8;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.preview-header {
  padding: 12px 16px;
  background: #f6f8fa;
  border-bottom: 1px solid #e1e4e8;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.preview-header h4 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #24292e;
}

.preview-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.preview-badge {
  background: #e1e4e8;
  color: #586069;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

.refresh-btn {
  background: none;
  border: 1px solid #d1d5da;
  border-radius: 4px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  color: #586069;
}

.refresh-btn:hover {
  background: #f3f4f6;
  border-color: #959da5;
}

.iframe-wrapper {
  flex: 1 1;
  min-height: 0;
  position: relative;
}

.preview-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.preview-footer {
  padding: 8px 16px;
  background: #f6f8fa;
  border-top: 1px solid #e1e4e8;
}

.preview-footer p {
  margin: 0;
  color: #586069;
}

.preview-footer code {
  background: #f3f4f6;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 11px;
  color: #d73a49;
}

.preview-loading, .preview-empty, .preview-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
  text-align: center;
}

.spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #0366d6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.preview-error {
  color: #cb2431;
}

.preview-error button {
  margin-top: 16px;
  padding: 6px 12px;
  background: #0366d6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}


@media (max-width: 480px) {
  .prevWrap{
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/Preview/PreviewRoot.css"],"names":[],"mappings":"AAAA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;;AAGA,2CAA2C;AAC3C;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n\n/* src/components/Preview/PreviewRoot.css */\n.prevWrap{\n  width: 400px;\n  min-width: 400px;\n}\n.preview-container {\n  display: flex;\n  flex-direction: column;\n  height: 95%;\n  border: 1px solid #e1e4e8;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.1);\n}\n\n.preview-header {\n  padding: 12px 16px;\n  background: #f6f8fa;\n  border-bottom: 1px solid #e1e4e8;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.preview-header h4 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #24292e;\n}\n\n.preview-info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.preview-badge {\n  background: #e1e4e8;\n  color: #586069;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.refresh-btn {\n  background: none;\n  border: 1px solid #d1d5da;\n  border-radius: 4px;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n  color: #586069;\n}\n\n.refresh-btn:hover {\n  background: #f3f4f6;\n  border-color: #959da5;\n}\n\n.iframe-wrapper {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n.preview-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.preview-footer {\n  padding: 8px 16px;\n  background: #f6f8fa;\n  border-top: 1px solid #e1e4e8;\n}\n\n.preview-footer p {\n  margin: 0;\n  color: #586069;\n}\n\n.preview-footer code {\n  background: #f3f4f6;\n  padding: 2px 4px;\n  border-radius: 3px;\n  font-size: 11px;\n  color: #d73a49;\n}\n\n.preview-loading, .preview-empty, .preview-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  padding: 40px;\n  text-align: center;\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #0366d6;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 16px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.preview-error {\n  color: #cb2431;\n}\n\n.preview-error button {\n  margin-top: 16px;\n  padding: 6px 12px;\n  background: #0366d6;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n\n@media (max-width: 480px) {\n  .prevWrap{\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
